import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Box, Container, Typography } from '@mui/material';

export const NotFoundPage: FC = () => {
	return (
		<Page title="404: Page Not Found – EAS Dashboard">
			<Container style={{ padding: '0px 20px 0 20px' }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: { md: 'row', xs: 'column' },
						alignItems: 'center',
						justifyContent: 'center',
						gap: '20px',
					}}
				>
					<Typography
						sx={{
							fontSize: { md: 130, xs: 80 },
							fontWeight: 600,
							marginTop: '20px',
						}}
					>
						404
					</Typography>
					<Box>
						<Typography
							sx={{
								fontSize: { md: 60, xs: 30 },
								fontWeight: 600,
								// marginTop: '20px',
							}}
						>
							Page Not Found
						</Typography>
						<Typography
							sx={{
								fontSize: { sm: 20, xs: 14 },
								fontWeight: 600,
								// marginTop: '20px',
							}}
						>
							Make sure the address is correct and the page hasn&apos;t moved.
						</Typography>
					</Box>
				</Box>
			</Container>
		</Page>
	);
};
